import Revolution from './Revolution.vue';

export default Revolution;
